import {
  FeatureFlagsContext,
  FeatureFlagsContextType,
} from "@/config/featureFlags/FeatureFlagsContext";
import { useContext, useState } from "react";
import {
  PriceCalculatorContext,
  PriceCalculatorContextType,
} from "../PriceCalculatorContext";
import { MovementType, PriceCalculatorFormData } from "../types/types";
import { useMultiLegPriceCalculation } from "./UseMultiLegPriceCalculation";
import { usePriceCalculation } from "./UsePriceCalculation";
import { transformCustomerToPriceCalculatorInput } from "../lib/transformers";
import { ApolloError } from "@apollo/client";

export const useCustomerPriceCalculation = () => {
  const { formData, setCustomerCalculatedState, setCustomerResult } =
    useContext(PriceCalculatorContext) as PriceCalculatorContextType;

  const { calculateMultiLegPrice, loading: multiLegCalculationLoading } =
    useMultiLegPriceCalculation(
      formData,
      setCustomerCalculatedState,
      setCustomerResult
    );

  const { calculatePrice, loading: sectionalCalculationLoading } =
    usePriceCalculation(
      formData,
      setCustomerCalculatedState,
      setCustomerResult
    );

  const [responseError, setResponseError] = useState<ApolloError | undefined>();

  const calculateCustomerPrice = async (
    formData: PriceCalculatorFormData,
    useCustomerInvoiceCurrency = true
  ) => {
    const input = transformCustomerToPriceCalculatorInput(
      formData,
      useCustomerInvoiceCurrency
    );
    if (formData.movementType === MovementType.MULTILEG) {
      const { error } = await calculateMultiLegPrice({
        variables: {
          input,
        },
      });
      setResponseError(error);
    } else {
      const { error } = await calculatePrice({
        variables: {
          input,
        },
      });
      setResponseError(error);
    }
  };

  return {
    calculateCustomerPrice,
    loading: sectionalCalculationLoading || multiLegCalculationLoading,
    error: responseError,
  };
};
